<template>
    <Captcha do-if="!skipCaptcha" ref="captcha" @verify="verify"></Captcha>
</template>

<script>
    import Captcha from "./Captcha";

    export default {
        name: "SkippableCaptcha",

        components: { Captcha },

        inject: ['skipCaptcha'],

        methods: {
            execute() {
                if (this.canSkip()) {
                    this.verify('');
                    return;
                }

                this.$refs.captcha.execute();
            },

            verify(code) {
                this.$emit('verify', code);
            },

            canSkip() {
                return this.skipCaptcha || false;
            },
        },
    }
</script>
